<template>
  <div>
    <main class="main" role="main">
      <div class="main_con">
        <div class="model_tab">
          <button
            :class="{ on: this.manufacturerId == 'SAMSUNG' }"
            value="SAMSUNG"
            @click="selectManufacturer"
          >
            #삼성
          </button>
          <button
            :class="{ on: this.manufacturerId == 'APPLE' }"
            value="APPLE"
            @click="selectManufacturer"
          >
            #애플
          </button>
          <button
            :class="{ on: this.manufacturerId == 'LG' }"
            value="LG"
            @click="selectManufacturer"
          >
            #LG
          </button>
          <button
            :class="{ on: this.manufacturerId == 'ETC' }"
            value="ETC"
            @click="selectManufacturer"
          >
            #기타
          </button>
        </div>
        <div class="list_top">
          <div class="tags tag_search" @click="showSortModal">
            <div class="tag">{{ sortName }}</div>
            <button class="btn_filter"></button>
          </div>
          <label class="search" style="flex: 0.9;">
            <input type="search" placeholder="이름" v-model="searchText" />
            <button class="i_search" @click="search"></button>
          </label>
          <!--<button class="btn_refresh"></button>-->
        </div>
        <div class="model_list">
          <ul class="model_list_ul">
            <li
              class="model_list_li"
              v-for="(item, index) in this.newDeviceList"
              v-bind:key="index"
              :class="{ on: activeIndex === index }"
              @click="selectDevice(item, index)"
            >
              <div class="inner">
                <div>
                  <input hidden :value="item.deviceId" :click="selectDevice" />
                  <div class="model_ttl">{{ item.modelName }}</div>
                  <div class="model_sub">{{ item.deviceName }}</div>
                </div>
                <div class="model_price" v-if="telecomIdVal != 'ALL'">
                  {{ toCurrency(item.factoryPrice) }}원
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="btm_btn">
        <div class="btn_wrap">
          <button
            class="btn"
            :disabled="activeIndex === undefined"
            @click="gotoPreviousPage"
          >
            선택
          </button>
        </div>
      </div>
    </main>
    <DeviceListSortModal
      ref="sortModal"
      v-show="modal"
      :isTelecomAll="isTelecomAll"
      @close="hideSortModal"
    />
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import {
  mapActions,
  mapState,
  mapGetters,
} from '@common/store/modules/xeronote';
import * as types from '@common/store/modules/xeronote/types';
import * as estimateTypes from '@common/store/modules/estimate/types';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import DeviceListSortModal from '@common/components/estimation/modal/DeviceListSortModal';
import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

export default {
  components: {
    DeviceListSortModal,
  },
  name: 'DeviceList',
  computed: {
    // ...mapGetters({
    //   deviceList: types.DEVICE_LIST,
    // }),
    ...mobileMapGetters({
      mobileDevice: mobileTypes.MOBILE_DEVICE,
      mobileDeviceDetail: mobileTypes.MOBILE_DEVICE_DETAIL,
    }),
    ...estimateMapGetters({
      estimationModel: estimateTypes.ESTIMATION_MODEL,
      quotationModel: estimateTypes.QUOTATION,
    }),
    isTelecomAll: function() {
      if (this.type === 'estimation') {
        if (this.estimationModel.type === 'DEFAULT') {
          return true;
        }
      }
      return false;
    },
  },
  async created() {
    await this.getDeviceList();
  },
  data() {
    return {
      type: this.$route.params.type || 'estimation',
      skipManufacturerIdByTelecom: [
        'SKYLIFE',
        'IYAGISKT',
        'IYAGIKT',
        'IYAGILG',
        'FREETSKT',
        'FREETKT',
        'FREETLG',
      ],
      manufacturerId: 'SAMSUNG',
      modal: false,
      sort: 'RECOMMAND',
      sortName: '퍼스 추천 순',
      activeIndex: undefined,
      newDeviceList: [],
      searchText: '',
      telecomIdVal: '',
    };
  },
  methods: {
    // ...mapActions([types.FETCH_DEVICE_LIST]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_DEVICE,
      mobileTypes.SELECT_MOBILE_DEVICE_DETAIL,
    ]),
    ...estimateMapActions([
      estimateTypes.SET_QUOTATION,
      estimateTypes.SET_ESTIMATION_MODEL,
    ]),

    async getDeviceList() {
      this.searchText = '';
      // const param = {
      //   manufacturerId: this.manufacturerId,
      //   telecomId:
      //     this.type === 'quotation'
      //       ? this.quotationModel.telecomId
      //       : this.estimationModel.telecomId,
      //   sort: this.sort,
      // };
      // if (this.isTelecomAll) {
      //   param.telecomId = 'ALL'; //7.20 업체 요청으로 견적요청서 일반인 경우 통신사 선택 상관없이 ALL로 조회
      //   this.telecomIdVal = 'ALL';
      // }

      let params = {
        callPart: 'CUSTOMER',
        telecomId:
          this.type === 'quotation'
            ? this.quotationModel.telecomId
            : this.estimationModel.telecomId,
        categoryId: 0,
        categoryIdSub: 0,
        keyword: this.searchText,
        orderType: this.sort,
        manufacturerId: this.manufacturerId,
      };
      if (this.skipManufacturerIdByTelecom.indexOf(params.telecomId) >= 0) {
        params.manufacturerId = null;
      }
      console.log('this.newDeviceList');
      console.log(this.newDeviceList);

      // await this[types.FETCH_DEVICE_LIST](params);
      await this[mobileTypes.SELECT_MOBILE_DEVICE](params);
      console.log('this.mobileDevice');
      console.log(this.mobileDevice);
      this.newDeviceList = this.mobileDevice.content;
      console.log('this.newDeviceList');
      console.log(this.newDeviceList);
    },
    async hideSortModal() {
      this.modal = false;
      this.sort = this.$refs.sortModal.sort.value;
      this.sortName = this.$refs.sortModal.sort.name;
      await this.getDeviceList();
    },
    showSortModal() {
      this.modal = true;
    },
    search() {
      if (this.mobileDevice.content) {
        const sText = this.searchText.toLowerCase();
        this.newDeviceList = this.mobileDevice.content.filter(
          p =>
            p.modelName.toLowerCase().indexOf(sText) >= 0 ||
            p.deviceName.toLowerCase().indexOf(sText) >= 0,
        );
      }
    },

    selectDevice(item, index) {
      this.activeIndex = index;
      if (this.type === 'quotation') {
        // 7.20 telecomId == 'ALL'일때는 deviceIdx로 비교할 수 없으므로 modelName으로 체크.
        /*if (this.param.telecomId !== 'ALL') {
          this.quotationModel.isChangeDevice =
            this.quotationModel.deviceIdx === item.device_idx ? false : true;
        } else {
        this.quotationModel.isChangeDevice =
          this.quotationModel.modelName === item.model_name ? false : true;
        }*/
        this.quotationModel.isChangeDevice =
          this.quotationModel.deviceIdx === item.deviceId ? false : true;
        this.quotationModel.deviceIdx = item.deviceId;
        this.quotationModel.deviceName = item.deviceName;
        this.quotationModel.deviceImage = item.deviceImage;
        this.quotationModel.deviceColors = item.colors;
        this.quotationModel.manufacturerId = item.manufacturerId;
        this.quotationModel.manufacturerName = item.manufacturerName;
        this.quotationModel.factoryPrice = parseInt(item.factoryPrice || 0);
        this.quotationModel.modelName = item.modelName;
        this.quotationModel.supportMoney = item.supportMoney;

        // console.log('itemitem');
        // console.log(item);
        // console.log(this.quotationModel);

        // alert(1);
      } else {
        if (this.estimationModel.steps == 5) {
          this.estimationModel.currentDeviceIdx = item.deviceId;
          this.estimationModel.currentDeviceName = item.deviceName;
          this.estimationModel.currentManufacturerId = item.manufacturerId;
          this.estimationModel.currentManufacturerName = item.manufacturerName;
          this.estimationModel.currentModelName = item.modelName;
          this.estimationModel.steps = 6;
        } else {
          this.estimationModel.needDeviceIdx = item.deviceId;
          this.estimationModel.needDeviceName = item.deviceName;
          this.estimationModel.needManufacturerId = item.manufacturerId;
          this.estimationModel.needManufacturerName = item.manufacturerName;
          this.estimationModel.needModelName = item.modelName;
          this.estimationModel.steps = 7;
        }
      }
    },
    gotoPreviousPage() {
      if (this.type === 'quotation') {
        console.log('this.quotationModel');
        console.log(this.quotationModel);
        this[estimateTypes.SET_QUOTATION](this.quotationModel).then(() => {
          this.$router.go(-1);
        });
      } else {
        this[estimateTypes.SET_ESTIMATION_MODEL](this.estimationModel).then(
          () => {
            this.$router.go(-1);
          },
        );
      }
    },
    async selectManufacturer(e) {
      this.manufacturerId = e.target.value;
      this.activeIndex = undefined;
      await this.getDeviceList();
    },

    toCurrency(val) {
      return val ? util.toCurrency(val) : 0;
    },
  },
};
</script>
